import React from "react";
import "./Eula.css"; // Assuming you have a CSS file for styling

const Eula = () => {
  return (
    <div className="eula-page">
      <h1>End-User License Agreement (EULA)</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>
      <p><strong>Last Updated:</strong> [Insert Date]</p>
      <p>
        This End-User License Agreement ("Agreement") is a legal agreement between you (the "User") and Servicing Headquarters, the provider of the web-based application known as Servicing Headquarters ("the App").
      </p>
      <p>
        By accessing or using the App, you agree to be bound by the terms of this Agreement. If you do not agree, do not use the App.
      </p>

      <h2>1. License Grant</h2>
      <p>
        Servicing Headquarters grants you a limited, non-exclusive, non-transferable, revocable license to access and use Servicing Headquarters solely for your internal business operations in the construction or related trades.
      </p>

      <h2>2. Restrictions</h2>
      <p>You may not:</p>
      <ul>
        <li>Copy, modify, or distribute the App or its content without written consent</li>
        <li>Reverse engineer, decompile, or attempt to extract source code</li>
        <li>Use the App for unlawful purposes or outside the scope of your business</li>
        <li>Share login credentials with unauthorized users or third parties</li>
      </ul>

      <h2>3. Termination</h2>
      <p>This license is effective until terminated. It will automatically terminate if:</p>
      <ul>
        <li>You violate any terms of this Agreement</li>
        <li>You cease to use the App</li>
        <li>Servicing Headquarters discontinues access to the App</li>
      </ul>
      <p>Upon termination, you must cease all use and delete any stored access or locally saved data related to the App.</p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content, design, source code, and related technology within the App are the exclusive property of Servicing Headquarters.
        You retain ownership of your business data uploaded into the App.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        Servicing Headquarters is provided "as is" and "as available."
        Servicing Headquarters shall not be liable for any direct, indirect, incidental, or consequential damages resulting from your use of or inability to use the App. This includes but is not limited to loss of business data, schedule conflicts, or operational downtime.
      </p>

      <h2>6. Data Storage & Use</h2>
      <p>Servicing Headquarters allows users to store and manage:</p>
      <ul>
        <li>Contractor, vendor, and employee information</li>
        <li>Licenses, certifications, and compliance data</li>
        <li>Scheduling, time tracking, invoicing, and business records</li>
      </ul>
      <p>Users are responsible for maintaining the accuracy of all stored data.</p>
      <p>We reserve the right to delete inactive accounts after a defined period, per our Privacy Policy.</p>

      <h2>7. Governing Law</h2>
      <p>
        This Agreement shall be governed by and construed in accordance with the laws of the state or jurisdiction where Servicing Headquarters is headquartered.
      </p>

      <h2>8. Modifications</h2>
      <p>
        We may update this EULA from time to time. Continued use of the App after changes are posted constitutes your acceptance of the updated terms.
      </p>

      <h2>Contact Us</h2>
      <p>
        For questions regarding this Agreement, contact:
      </p>
      <p>
        Servicing Headquarters<br />
        Email: servicinghq@gmail.com
      </p>
    </div>
  );
};

export default Eula;